<template>
  <aicc-page :pageId="this.contextPageId">
    <ur-area>
      <ur-form-box toggleable column="5">
        <ur-form-row>
          <ur-form-item
            :label="$t('MSG_TXT_CAMPAIGN_PERIOD')"
            colSpan="2"
            labelAlign="right"
          >
            <aicc-range-picker
              v-model="rangeDate"
              init="day-6"
              inputType="YYYY-MM-DD"
              modelType="YYYYMMDD"
              :min-date="minDate"
              confirmLabel="확인"
              cancelLabel="취소"
              strict-range
              autoConfirm
              limitRange="92"
            ></aicc-range-picker>
          </ur-form-item>
          <ur-form-item
            :label="$t('MSG_TXT_CAMPAIGN')"
            colSpan="2"
            labelAlign="right"
          >
            <!-- <ur-multi-dropdown v-model="selectedSchedule" selectAll :items="selectScheduleOptions" placeholder="모든 캠페인"/> -->
            <autoMultiDropdown
              v-model="selectedcampaignValue"
              selectAll
              :items="campaignItems"
              :itemsSize="300"
              placeholder="전체"
            />
          </ur-form-item>
        </ur-form-row>
        <ur-form-row>
          <ur-form-item label="상태" colSpan="2" labelAlign="right">
            <autoMultiDropdown
              v-model="selectedStatus"
              selectAll
              :searchable="false"
              :items="statusItems"
              :itemsSize="300"
              placeholder="전체"
            />
            <!-- <autoMultiDropdown v-model="selectedStatus" selectAll :items="selectStatusOptions" placeholder="전체"/> -->
          </ur-form-item>
          <ur-form-item colSpan="2"> </ur-form-item>
          <ur-form-item no-label noFlex>
            <ur-button
              shape="solid"
              primary
              @click="getOutCallScheduleStatisticsList"
              >조회</ur-button
            >
          </ur-form-item>
        </ur-form-row>
      </ur-form-box>
      <ur-data-grid
        :headers="scheduleListColumns"
        :options="scheduleListOptions"
        :data-source="dataList"
        @grid:row-click="showScheduleDetail"
        ref="grid"
      >
        <template #header>
          <ur-data-grid-header-row>
            <ur-data-grid-header-cell rowspan="2" />
            <ur-data-grid-header-cell rowspan="2" />
            <ur-data-grid-header-cell rowspan="2" class="line" />
            <ur-data-grid-header-cell
              colspan="4"
              text="통화시도 기준 (재시도 포함)"
              class="headerCtnBlock1"
            />
            <ur-data-grid-header-cell
              colspan="3"
              text="수신번호 기준"
              class="headerCtnBlock1"
            />
            <ur-data-grid-header-cell
              colspan="3"
              text="수신번호 기준 시나리오"
              class="headerCtnBlock1"
            />
            <ur-data-grid-header-cell rowspan="2" />
          </ur-data-grid-header-row>
          <ur-data-grid-header-row>
            <ur-data-grid-header-cell class="customline" />
            <ur-data-grid-header-cell class="customline" />
            <ur-data-grid-header-cell class="customline" />
            <ur-data-grid-header-cell class="rightline" />

            <ur-data-grid-header-cell class="customline" />
            <ur-data-grid-header-cell class="customline" />
            <ur-data-grid-header-cell class="rightline" />

            <ur-data-grid-header-cell class="customline" />
            <ur-data-grid-header-cell class="customline" />
            <ur-data-grid-header-cell class="rightline" />
          </ur-data-grid-header-row>
        </template>
        <template #right-info>
          <ur-button
            shape="solid"
            color="white"
            large
            @click="onClickDownload"
            >{{ $t("MSG_BTN_DOWNLOAD_DATA") }}</ur-button
          >
          <!-- <ur-button primary @click="registerOutCallSchedule"><i class="new_campagin_icon"/>{{$t("MSG_BTN_NEW_CAMPAIGN")}}</ur-button> -->
          <ur-button primary large @click="registerOutCallSchedule"
            ><i class="new_campagin_icon" />{{
              $t("MSG_BTN_NEW_CAMPAIGN")
            }}</ur-button
          >
        </template>
      </ur-data-grid>

      <schedule-detail-popup
        ref="scheduleDetailPopup"
        :pageId="contextPageId"
        :pageInitialData="pageInitialData"
        @closeDetailPopup="closeDetailPopup"
      />

      <div>
        <ur-snackbar ref="snackbar" :duration="3000">
          <template v-slot:action>
            <ur-button @click="redirectMntPage()" primary borderless
              >캠페인 목록보기</ur-button
            >
          </template>
        </ur-snackbar>
      </div>
    </ur-area>
    <!-- <ur-pagination :pagination="page" @move="changeCurrentPage" /> -->
  </aicc-page>
</template>

<script>
import { align } from "suneditor/src/plugins";
import BasePage from "~cm/components/BasePage";
import { urDataSet } from "uidev-component/index.js";
import urDataGrid from "@uidev/grid/urDataGrid/urDataGrid";
import autoMultiDropdown from "../../components/CMP_AIC_00001.vue";
import urCustomDropHolder from "../../components/CMP_AIC_00002.vue";
import scheduleDetailPopup from "../../components/CMP_AIC_00005/CMP_AIC_00005.vue";
// import - libraries (node modules)
// import - local files (js, vue, ...)
// 페이지 에서 사용하는 code 목록 기술
// import p01 from './Template01_P01';

function min(x, y) {
  return x < y ? x : y;
}
function max(x, y) {
  return x > y ? x : y;
}

const CODE_KEYS = ["COD_PAGE_TYPE"];
window.setOutCallSchduleInfoFromChild = function (mode, data) {
  // console.log("Called from child. ", mode, data)
  modeValueFromChild = mode;
  outCallSchduleInfoFromChild = data;
};
var modeValueFromChild;
var outCallSchduleInfoFromChild;

export default {
  name: "PGE_AIC_00007",
  components: {
    // p01,
    autoMultiDropdown: autoMultiDropdown,
    urDataGrid,
    urCustomDropHolder,
    scheduleDetailPopup,
  },
  extends: BasePage,
  data() {
    return {
      autoConfirm: true,
      reloadSelected: true,
      scheduleListDataSet: new urDataSet(),
      scheduleListOptions: {
        infinityScroll: true,
        timezone: +9,
        rowHeight: 54,
        height: 0,
        defaultFieldWidth: 200,
        msgTotal: "총 #",
        msgAscending: "오름차순 정렬",
        msgDescending: "내림차순 정렬",
        msgEmptyData: "캠페인 진행형황 데이터가 없습니다.",
      },
      scheduleListColumns: [
        {
          value: "scheduleStatus",
          text: this.$i18n.t("MSG_TXT_STATUS"),
          width: 76,
          sort: true,
          key: true,
          align: "left",
          component: {
            props: ["row", "value", "text"],
            template: `<span><strong :class="statusClass(row)">{{text}}</strong></span>`,
            data() {
              return {
                scheduleStatusClass: {
                  작성중: "status waiting",
                  대기: "status waiting",
                  진행중: "status ing",
                  완료: "status done",
                  중지: "status cancel",
                  중지S: "status cancel",
                  취소: "status cancel",
                  취소S: "status cancel",
                },
              };
            },
            computed: {
              statusClass() {
                return (row) => {
                  return this.scheduleStatusClass[this.row.scheduleStatus];
                };
              },
            },
          },
        },
        // {value:'scheduleName' ,text: this.$i18n.t('MSG_TXT_CAMPAIGN_NAME') ,sort:true},
        {
          value: "scheduleName",
          text: this.$i18n.t("MSG_TXT_CAMPAIGN"),
          sort: true,
          align: "left",
          component: {
            props: ["row", "value", "text"],
            template: `<span><strong>{{this.row.scheduleName}}</strong><br/><span class="tel">{{this.row.sipNumber}}</span></span>`,
          },
        },
        {
          value: "schedulePeriod",
          text: this.$i18n.t("MSG_TXT_CAMPAIGN_PERIOD"),
          width: 95,
          sort: true,
          align: "left",
          component: {
            props: ["row", "value", "text"],
            template: `<span>{{this.row.startDate}} ~<br/>{{this.row.endDate}}</span>`,
          },
          customClass: "data_tbl_line_right",
        },
        {
          value: "callTotalCnt",
          text: "통화시도" /* this.$i18n.t('MSG_TXT_CALL_ATTEMPT') */,
          type: "number",
          width: 80,
          sort: true,
          align: "right",
          component: {
            props: ["row", "value", "text"],
            template: `<span>{{text}}</span>`,
          },
        },
        {
          value: "callSuccessCnt",
          text: "통화연결" /* this.$i18n.t('MSG_TXT_CALL_SUCCESS')  */,
          type: "number",
          width: 80,
          sort: true,
          align: "right",
          component: {
            props: ["row", "value", "text"],
            template: `<span>{{text}}</span>`,
          },
        },
        {
          value: "callReserveCnt",
          text: "예약접수" /* this.$i18n.t('MSG_TXT_CALL_RESERVE')  */,
          type: "number",
          width: 80,
          sort: true,
          align: "right",
          component: {
            props: ["row", "value", "text"],
            template: `<span>{{text}}</span>`,
          },
        },
        {
          value: "callSuccessRatio",
          text: "연결률" /* this.$i18n.t('MSG_TXT_CALL_SUCCESS_RATIO') */,
          type: "number",
          width: 75,
          sort: true,
          align: "right",
          component: {
            props: ["row", "value", "text"],
            template: `<span><strong>{{text}}%</strong></span>`,
          },
          customClass: "data_tbl_list_state",
        },
        {
          value: "callCntByCallee",
          text: "수행번호" /* this.$i18n.t('MSG_TXT_CALL_ATTEMPT_BY_CALLEE')  */,
          type: "number",
          width: 80,
          sort: true,
          align: "right",
          component: {
            props: ["row", "value", "text"],
            template: `<span>{{text}}</span>`,
          },
        },
        {
          value: "callSuccessCntByCallee",
          text: "통화연결" /* this.$i18n.t('MSG_TXT_CALL_SUCCESS_BY_CALLEE')  */,
          type: "number",
          width: 80,
          sort: true,
          align: "right",
          component: {
            props: ["row", "value", "text"],
            template: `<span>{{text}}</span>`,
          },
        },
        {
          value: "callSuccessRatioByCallee",
          text: "연결률" /* this.$i18n.t('MSG_TXT_CALL_SUCCESS_RATIO_BY_CALLEE') */,
          type: "number",
          width: 75,
          sort: true,
          align: "right",
          component: {
            props: ["row", "value", "text"],
            template: `<span><strong>{{text}}%</strong></span>`,
          },
          customClass: "data_tbl_list_state",
        },
        {
          value: "scenarioStartCntByCallee",
          text: this.$i18n.t("MSG_TXT_SCENARIO_START"),
          type: "number",
          width: 75,
          sort: true,
          align: "right",
          component: {
            props: ["row", "value", "text"],
            template: `<span>{{text}}</span>`,
          },
        },
        {
          value: "scenarioEndCntByCallee",
          text: this.$i18n.t("MSG_TXT_SCENARIO_END"),
          type: "number",
          width: 75,
          sort: true,
          align: "right",
          component: {
            props: ["row", "value", "text"],
            template: `<span>{{text}}</span>`,
          },
        },
        {
          value: "scenarioEndRatioByCallee",
          text: this.$i18n.t("MSG_TXT_SCENARIO_END_RATIO"),
          type: "number",
          width: 75,
          sort: true,
          align: "right",
          component: {
            props: ["row", "value", "text"],
            template: `<span><strong>{{text}}%</strong></span>`,
          },
          customClass: "data_tbl_list_state",
        },
        {
          value: "calleeCnt",
          text: "수신리스트",
          type: "number",
          width: 90,
          sort: true,
          align: "right",
          component: {
            props: ["row", "value", "text"],
            template: `<span>{{text}}</span>`,
          },
        },
      ],
      campaignListAsk: {
        tenantId: this.$store.getters.userInfo.tenantId,
        sdate: "",
        edate: "",
      },
      //rangeDate: [utils.addDay(utils.now('YYYYMMDD'), -7).substring(0, 8), utils.now('YYYYMMDD')],
      rangeDate: [],
      rangePickerValue: ["", ""],
      startDateValue: "",
      endDateValue: "",
      minDate: "2021-01-01",
      outCallSchedulesAsk: {
        startDate: "",
        endDate: "",
        scheduleIdList: [],
        scheduleStatusList: [],
      },
      statusItems: [],

      sDate: utils.now("YYYYMMDD"),
      eDate: utils.addDay(utils.now("YYYYMMDD"), 7).substring(0, 8),

      selectedSchedule: [],
      selectedcampaignValue: [],
      campaignDropdown: [],

      selectedStatus: [],
      // selectStatusOptions: [
      //   // {value:'A',text:this.$i18n.t('MSG_TXT_ITEMSTATUS_PREV')},
      //   // {value:'B',text:this.$i18n.t('MSG_TXT_ITEMSTATUS_WAIT')},
      //   {value:'C',text:this.$i18n.t('MSG_TXT_ITEMSTATUS_ING')},
      //   {value:'D',text:this.$i18n.t('MSG_TXT_ITEMSTATUS_DONE')},
      //   {value:'E',text:this.$i18n.t('MSG_TXT_ITEMSTATUS_PAUSE')},
      //   {value:'F',text:this.$i18n.t('MSG_TXT_ITEMSTATUS_CANCEL')},
      // ],

      // 페이지 에서 사용하는 code 목록이 저장 될 field
      isShownPopup: false,

      codes: {
        COD_MDLE: [
          {
            label: "",
            key: "",
          },
        ],
      },
      // 이하 data field는 자유롭게
      selectedCodeValue: {
        COD_MDLE: {
          label: "",
          key: "",
        },
      },
      count: 0,

      listLocaldata: [],
      gridColumns0: [
        {
          text: this.$i18n.t("MSG_TXT_STATUS"),
          datafield: "scheduleStatus",
        },
        {
          text: this.$i18n.t("MSG_TXT_CAMPAIGN_NAME"),
          datafield: "scheduleName",
        },
        {
          text: this.$i18n.t("MSG_TXT_SIP_NUMBER"),
          datafield: "sipNumber",
        },
        {
          text: this.$i18n.t("MSG_TXT_CAMPAIGN_PERIOD"),
          datafield: "schedulePeriod",
        },
        {
          text: this.$i18n.t("MSG_TXT_CALL_ATTEMPT"),
          datafield: "callTotalCnt",
        },
        {
          text: this.$i18n.t("MSG_TXT_CALL_SUCCESS"),
          datafield: "callSuccessCnt",
        },
        {
          text: this.$i18n.t("MSG_TXT_CALL_RESERVE"),
          datafield: "callReserveCnt",
        },
        {
          text: this.$i18n.t("MSG_TXT_CALL_SUCCESS_RATIO"),
          datafield: "callSuccessRatio",
        },
        {
          text: this.$i18n.t("MSG_TXT_CALL_ATTEMPT_BY_CALLEE"),
          datafield: "callCntByCallee",
        },
        {
          text: this.$i18n.t("MSG_TXT_CALL_SUCCESS_BY_CALLEE"),
          datafield: "callSuccessCntByCallee",
        },
        {
          text: this.$i18n.t("MSG_TXT_CALL_SUCCESS_RATIO_BY_CALLEE"),
          datafield: "callSuccessRatioByCallee",
        },
        {
          text: this.$i18n.t("MSG_TXT_SCENARIO_START"),
          datafield: "scenarioStartCntByCallee",
        },
        {
          text: this.$i18n.t("MSG_TXT_SCENARIO_END"),
          datafield: "scenarioEndCntByCallee",
        },
        {
          text: this.$i18n.t("MSG_TXT_SCENARIO_END_RATIO"),
          datafield: "scenarioEndRatioByCallee",
        },
        {
          text: this.$i18n.t("MSG_TXT_RECV_DIAL_NUMBER"),
          datafield: "calleeCnt",
        },
      ],

      dataList: [],
      items: [],
      pageInitialData: {},
      headers: [
        {
          text: this.$i18n.t("MSG_TXT_STATUS"),
          value: "scheduleStatus",
          align: "left",
          width: "20px",
          sortable: true,
        },
        {
          text: this.$i18n.t("MSG_TXT_CAMPAIGN_NAME"),
          value: "scheduleName",
          width: "70px",
          sortable: true,
        },
        {
          text: this.$i18n.t("MSG_TXT_SIP_NUMBER"),
          value: "sipNumber",
          width: "25px",
          sortable: true,
        },
        {
          text: this.$i18n.t("MSG_TXT_CAMPAIGN_PERIOD"),
          value: "schedulePeriod",
          width: "30px",
          sortable: true,
        },
        {
          text: this.$i18n.t("MSG_TXT_CALL_ATTEMPT"),
          value: "callTotalCnt",
          width: "20px",
          sortable: true,
        },
        {
          text: this.$i18n.t("MSG_TXT_CALL_SUCCESS"),
          value: "callSuccessCnt",
          width: "20px",
          sortable: true,
        },
        {
          text: this.$i18n.t("MSG_TXT_CALL_RESERVE"),
          value: "callReserveCnt",
          width: "20px",
          sortable: true,
        },
        {
          text: this.$i18n.t("MSG_TXT_CALL_SUCCESS_RATIO"),
          value: "callSuccessRatio",
          width: "20px",
          sortable: true,
        },
        {
          text: this.$i18n.t("MSG_TXT_CALL_ATTEMPT_BY_CALLEE"),
          value: "callCntByCallee",
          width: "20px",
          sortable: true,
        },
        {
          text: this.$i18n.t("MSG_TXT_CALL_SUCCESS_BY_CALLEE"),
          value: "callSuccessCntByCallee",
          width: "20px",
          sortable: true,
        },
        {
          text: this.$i18n.t("MSG_TXT_CALL_SUCCESS_RATIO_BY_CALLEE"),
          value: "callSuccessRatioByCallee",
          width: "20px",
          sortable: true,
        },
        {
          text: this.$i18n.t("MSG_TXT_SCENARIO_START"),
          value: "scenarioStartCntByCallee",
          width: "20px",
          sortable: true,
        },
        {
          text: this.$i18n.t("MSG_TXT_SCENARIO_END"),
          value: "scenarioEndCntByCallee",
          width: "20px",
          sortable: true,
        },
        {
          text: this.$i18n.t("MSG_TXT_SCENARIO_END_RATIO"),
          value: "scenarioEndRatioByCallee",
          width: "20px",
          sortable: true,
        },
        {
          text: this.$i18n.t("MSG_TXT_RECV_DIAL_NUMBER"),
          value: "calleeCnt",
          width: "20px",
          sortable: true,
        },
      ],

      selected: [],
      page: {
        rowsPerPage: 10,
        currentPage: 1,
        totalPages: 1,
        totalItems: 0,
      },
    };
  },

  created() {
    //this.tableOptions.msgEmptyData = this.$i18n.t('MSG_TXT_NO_DATA');
    //this.tableOptions.msgEmptyData='';
  },

  computed: {
    campaignItems() {
      return this.campaignDropdown;
    },
  },

  watch: {
    rangeDate: function (newVal, oldVal) {
      this.onCampaignList();
      const temp = this.selectStatusOptions();
      this.statusItems = [];
      this.selectedStatus = [];
      for (let index in temp) {
        this.statusItems.push(temp[index]);
        this.selectedStatus.push(temp[index]);
      }
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.onLoad();
    });

    this.scheduleListOptions.height =
      $(".ur-area").css("height").replace("px", "") - 252;
    window.addEventListener("resize", this.handleResize);
    this.getOutCallScheduleStatisticsList();

    var fromDate = this.getTodayYmd();
    var toDate = utils.addDay(fromDate, 7);
    toDate = utils.dateformatToClient(toDate, "S"); // 날짜까지만 표시
    this.selectedRangeDate = { from: fromDate, to: toDate };

    this.rangePickerValue = [];
    this.rangePickerValue.push(fromDate);
    this.rangePickerValue.push(toDate);
  },

  beforeUpdate() {},

  updated() {},

  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },

  destroyed() {},

  methods: {
    selectStatusOptions() {
      return [
        // {value:'A',text:this.$i18n.t('MSG_TXT_ITEMSTATUS_PREV')},
        // {value:'B',text:this.$i18n.t('MSG_TXT_ITEMSTATUS_WAIT')},
        {
          value: "C",
          text: "진행중" /* this.$i18n.t('MSG_TXT_ITEMSTATUS_ING') */,
        },
        { value: "D", text: this.$i18n.t("MSG_TXT_ITEMSTATUS_DONE") },
        { value: "E", text: this.$i18n.t("MSG_TXT_ITEMSTATUS_PAUSE") },
        { value: "F", text: this.$i18n.t("MSG_TXT_ITEMSTATUS_CANCEL") },
      ];
    },
    showSnackbar(message) {
      this.$refs.snackbar.show({ text: message });
    },
    onLoad() {
      this.onCampaignList();
    },
    // <multi-select> @confirm
    // when confirm clicked.
    onMultiSelectConfirm(selectedItem) {
      //console.log(`[Sample] MultiSelect.onConfirm() : selectedItem = ${JSON.stringify(selectedItem)}`);
    },

    // <multi-select> @select
    // Emitted after selecting an option.
    onAfterSelecting(selectedItem, id) {
      //console.log(`[Sample] MultiSelect.onAfterSelecting() : selectedItem = ${JSON.stringify(selectedItem)}, id = ${id}`);
    },

    onOpenPopupClick() {
      this.isShownPopup = true;
    },

    clickSort(header) {
      this.$notify("Sort with '" + header.text + "' field.");
      this.dataList.sort((x, y) => {
        if (x[header.value] < y[header.value])
          return -1 * (header.desc ? 1 : -1);
        if (x[header.value] > y[header.value])
          return 1 * (header.desc ? 1 : -1);
        return 0;
      });
      this.dataToItems();
    },

    onCampaignList() {
      this.campaignListAsk.sdate = this.rangeDate[0];
      this.campaignListAsk.edate = this.rangeDate[1];

      // 최대 검색가능일정 31일 (=얼럿으로는 1개월로 표시),
      // 캘린더 과거날짜 선택의 제한은 없으나 2021년 캘린더부터 캘린더 조회됨
      var fromDateObj = new Date(
        this.rangeDate[0].substring(0, 4),
        this.rangeDate[0].substring(4, 6) - 1,
        this.rangeDate[0].substring(6, 8)
      );
      var toDateObj = new Date(
        this.rangeDate[1].substring(0, 4),
        this.rangeDate[1].substring(4, 6) - 1,
        this.rangeDate[1].substring(6, 8)
      );
      var searchDateCheck = Math.floor(
        Math.abs(toDateObj.getTime() - fromDateObj.getTime()) /
          (1000 * 60 * 60 * 24)
      );
      if (searchDateCheck > 91) {
        utils.aiccMessageBox(
          "경고",
          this.$t("MSG_TXT_SEARCH_UNTIL_3MONTH"),
          "확인",
          () => {
            this.rangeDate = [
              utils.now("YYYYMMDD"),
              utils.addDay(utils.now("YYYYMMDD"), 2).substring(0, 8),
            ];
          }
        );
        return;
      }

      http
        .request(this.contextPageId, "DTS_AIC_00001", {
          query: this.campaignListAsk,
        })
        .then((response) => {
          //console.log(response.data);
          const items = [];
          utils.forEach(response.data.list, (obj) => {
            items.push({ text: obj.scheduleName, value: obj.scheduleId });
          });
          this.campaignDropdown = items;
          this.selectedcampaignValue = items;
        });
    },

    registerOutCallSchedule() {
      // 등록버튼 누른 경우 작성화면을 윈도우 팝업으로 띄운다.
      let modeValue = "I";
      let url = `/popup.html#/PGE_AIC_00003?mode=${modeValue}`;
      this.registerPopupWindow = window.open(
        window.location.pathname + url,
        "",
        "width=1500,height=900,location=no,menubar=no,status=no,toolbar=no,resizable=yes"
      );
      this.registerPopupWindow.addEventListener(
        "beforeunload",
        this.onClosePagePopup
      );
    },

    getOutCallScheduleStatisticsList() {
      console.log("scroll::::" + window.scrollY);
      console.log($(".ur-data-grid__content__scroll-wrapper").css("overflow"));
      this.outCallSchedulesAsk.startDate = this.rangeDate[0];
      this.outCallSchedulesAsk.endDate = this.rangeDate[1];

      this.outCallSchedulesAsk.scheduleIdList = [];
      this.outCallSchedulesAsk.scheduleStatusList = [];

      // select box 선택한 값이 있으면 Ask 데이터에 넣는다.
      if (this.selectedcampaignValue.length > 0) {
        for (let schedule of this.selectedcampaignValue) {
          this.outCallSchedulesAsk.scheduleIdList.push(schedule.value);
        }
      }
      if (this.selectedStatus.length > 0) {
        for (let status of this.selectedStatus) {
          this.outCallSchedulesAsk.scheduleStatusList.push(status.value);
          // 중지(E),취소(F)가 검색 조건에 있는 경우 시스템중지(G), 시스템취소(H)도 같이 가져온다.
          if (status.value === "E") {
            this.outCallSchedulesAsk.scheduleStatusList.push("G");
          }
          if (status.value === "F") {
            this.outCallSchedulesAsk.scheduleStatusList.push("H");
          }
        }
      }
      if (this.selectedStatus.length === this.selectStatusOptions.length) {
        const tempSelectStatus = this.selectStatusOptions();

        for (let index in tempSelectStatus) {
          this.outCallSchedulesAsk.scheduleStatusList.push(
            tempSelectStatus[index].value
          );
          // 중지(E),취소(F)가 검색 조건에 있는 경우 시스템중지(G), 시스템취소(H)도 같이 가져온다.
          if (tempSelectStatus[index].value === "E") {
            this.outCallSchedulesAsk.scheduleStatusList.push("G");
          }
          if (tempSelectStatus[index].value === "F") {
            this.outCallSchedulesAsk.scheduleStatusList.push("H");
          }
          // this.outcallResultItems.push(tempOutcallResult[index]);
          // this.selectedOutcallResult.push(tempOutcallResult[index]);
        }
      }

      /* 2021.12.27 : (상품쪽 요구사항)  조회하는 동안에는 NoData 표시 하지 않기*/
      this.scheduleListOptions.msgEmptyData = "";
      //console.log(JSON.stringify(this.outCallSchedulesAsk));

      // 서버 API 호출
      http
        .request(this.$options.name, "DTS_AIC_00007", {
          data: this.outCallSchedulesAsk,
        })
        .then((response) => {
          //console.log(JSON.stringify(response.data));

          // list 데이터 초기화
          this.listLocaldata = [];
          this.items = [];

          // 화면에 보여 줄 데이터
          let rowList = [];

          for (let schedule of response.data) {
            // schedule select box 채움
            let obj = {};
            obj["value"] = schedule.scheduleId;
            obj["text"] = schedule.scheduleName;
            /* // console.log(this.selectScheduleOptions.some(e => e.value === obj.value));
            if(!this.selectedcampaignValue.some(e => e.value === obj.value)) {
              this.selectedcampaignValue.push(obj);
            }
             */
            // row list 채움
            let row = {};
            let startDate =
              schedule.startDate.substring(0, 4) +
              "." +
              schedule.startDate.substring(4, 6) +
              "." +
              schedule.startDate.substring(6, 8);
            let endDate =
              schedule.endDate.substring(0, 4) +
              "." +
              schedule.endDate.substring(4, 6) +
              "." +
              schedule.endDate.substring(6, 8);
            let schedulePeriod = schedule.startDate + "~" + schedule.endDate;
            row.scheduleId = schedule.scheduleId;
            row.startDate = startDate;
            row.endDate = endDate;
            row.schedulePeriod = schedulePeriod;
            row.scheduleName = schedule.scheduleName;
            row.sipNumber = schedule.sipNumber;
            if (schedule.scheduleStatus === "A") row.scheduleStatus = "작성중";
            else if (schedule.scheduleStatus === "B")
              row.scheduleStatus = "대기";
            else if (schedule.scheduleStatus === "C")
              row.scheduleStatus = "진행중";
            else if (schedule.scheduleStatus === "D")
              row.scheduleStatus = "완료";
            else if (schedule.scheduleStatus === "E")
              row.scheduleStatus = "중지";
            else if (schedule.scheduleStatus === "F")
              row.scheduleStatus = "취소";
            else if (schedule.scheduleStatus === "G")
              row.scheduleStatus = "중지S";
            else if (schedule.scheduleStatus === "H")
              row.scheduleStatus = "취소S";
            // else row.scheduleStatus = "취소";
            // row.scheduleStatus = schedule.scheduleStatus;
            row.callTotalCnt = schedule.callTotalCnt;
            row.callSuccessCnt = schedule.callSuccessCnt;
            row.callReserveCnt = schedule.callReserveCnt;
            row.callSuccessRatio = schedule.callSuccessRatio;
            row.callCntByCallee = schedule.callCntByCallee;
            row.callSuccessCntByCallee = schedule.callSuccessCntByCallee;
            row.callSuccessRatioByCallee = schedule.callSuccessRatioByCallee;
            row.scenarioStartCntByCallee = schedule.scenarioStartCntByCallee;
            row.scenarioEndCntByCallee = schedule.scenarioEndCntByCallee;
            row.scenarioEndRatioByCallee = schedule.scenarioEndRatioByCallee;
            row.calleeCnt = schedule.calleeCnt;

            row.senarioDescription = schedule.scenarioId;
            row.calleeCount = schedule.calleeCount;
            row.scheduleDescription = schedule.scheduleDescription;
            row.insertDate = utils.toStringByFormat(
              schedule.insertTime,
              "YYYY-MM-DD"
            );
            row.modifyDate = "-";
            row.userId = schedule.usrId;
            rowList.push(row);
          }

          // response.data 데이터가 있으면
          this.listDataset.setRawData(rowList);
          this.dataList = rowList;
          console.log(rowList.length);
          if (rowList.length === 0) {
            this.scheduleListOptions.msgEmptyData =
              "선택하신 조건의 조회결과가 없습니다.";
          }
        })
        .catch((error) => {
          /*           console.log(error); */
          utils.aiccMessageBox(
            "알림",
            "잠시 후 다시 시도해주세요.",
            "확인",
            null
          );
        });
    },
    closeDetailPopup() {
      console.log(outCallSchduleInfoFromChild);
      // PGE_AIC_0004(목록) -> CMP_AIC_0005(상세조회 모달) -> 수정, 복사(PGE_AIC_00003) 순서로 호출되는 경우
      // 수정, 복사(PGE_AIC_00003) 완료되면 CMP_AIC_0005(상세조회 모달)이 닫히고 PGE_AIC_0004(목록)에서 메시지를 보여준다.
      this.onChildWindowClosed();
      this.getOutCallScheduleStatisticsList();
    },
    onChildWindowClosed() {
      console.log("onChildWindowClosed() was called.");
      if (
        !outCallSchduleInfoFromChild ||
        !outCallSchduleInfoFromChild.scheduleId
      ) {
        return;
      }
      let scheduleName = "";
      if (!utils.isEmpty(outCallSchduleInfoFromChild.scheduleName)) {
        scheduleName = "'" + outCallSchduleInfoFromChild.scheduleName + "'";
      }
      if (modeValueFromChild === "I" || modeValueFromChild === "C") {
        this.showSnackbar(
          utils.strFormat("{0} 캠페인이 등록되었습니다.", scheduleName)
        );
      }
      if (modeValueFromChild === "U" || modeValueFromChild === "UB") {
        this.showSnackbar(
          utils.strFormat("{0} 캠페인이 수정되었습니다.", scheduleName)
        );
      }
      outCallSchduleInfoFromChild = "";
      this.getOutCallScheduleStatisticsList();
    },

    checkAllSelectBox(isForceCheckAll) {
      // console.log('checkAllSelectBox');

      if (this.selectedSchedule.length === 0 || isForceCheckAll) {
        while (this.selectedSchedule.length !== 0) {
          this.selectedSchedule.pop();
        }
        for (let schedule of this.selectScheduleOptions) {
          this.selectedSchedule.push(schedule);
        }
      }

      if (this.selectedStatus.length === 0 || isForceCheckAll) {
        while (this.selectedStatus.length !== 0) {
          this.selectedStatus.pop();
        }
        for (let status of this.selectStatusOptions) {
          this.selectedStatus.push(status);
        }
      }
    },
    redirectMntPage() {
      this.$store.getters.lnbShowed;
      // this.$router.push({
      //   path: '/Redirect',
      //   query: { pageId: 'PGE_AIC_00014', campaignValue: value.scheduleInfo.scheduleId },
      // });
      this.getComponent("aicc-frame").syncMenuStateByPageId("PGE_AIC_00004");
      utils.goPage("PGE_AIC_00004", null);
    },
    getTodayYmd() {
      return utils.now("YYYY-MM-DD");
    },

    getTodayHHmm() {
      return utils.now("HH:mm");
    },

    downloadExcel() {
      const sPageId = this.$options.name;
      const objGridColumns = this.gridColumns0;
      const objGridDataset = this.listDataset;
      const sToday = utils.now("YYYYMMDDHHmmss");
      const sExcelName = `AICC_SCHEDULE_STATISTICS_${sToday}.csv`;
      utils.downloadGridToExcel(
        sPageId,
        objGridColumns,
        objGridDataset,
        sExcelName,
        {}
      );
    },
    /* onClickDownload() {
      const sCsvName =`AICC_SCHEDULE_STATISTICS_${utils.now('YYYYMMDDHHmmss')}.csv`;
      this.$refs['grid'].exportCsv(sCsvName);
    },

 
       */
    handleResize(event) {
      this.$nextTick(() => {
        this.scheduleListOptions.height =
          $(".ur-area").css("height").replace("px", "") - 252;
      });
    },
    onClickDownload() {
      var csvArray = [];
      var rowData = this.$refs.grid.getViewData();
      // set header
      var header1 = [
        "",
        "",
        "",
        "통화시도 기준 (재시도 포함)",
        "통화시도 기준 (재시도 포함)",
        "통화시도 기준 (재시도 포함)",
        "통화시도 기준 (재시도 포함)",
        "수신번호 기준",
        "수신번호 기준",
        "수신번호 기준",
        "수신번호 기준 시나리오",
        "수신번호 기준 시나리오",
        "수신번호 기준 시나리오",
        "",
      ];
      var header2 = [
        "상태",
        "캠페인",
        "수행일정",
        "통화시도",
        "통화연결",
        "예약접수",
        "연결률",
        "수행번호",
        "통화연결",
        "연결률",
        "시작",
        "종료",
        "종료률",
        "수신리스트",
      ];
      csvArray.push(header1);
      csvArray.push(header2);
      var rowDataArray = [];
      rowData.forEach((row) => {
        var rowItem = [];
        rowItem.push(row.scheduleStatus);
        rowItem.push(row.scheduleName);
        rowItem.push(row.schedulePeriod);
        rowItem.push(row.callTotalCnt);
        rowItem.push(row.callSuccessCnt);
        rowItem.push(row.callReserveCnt);
        rowItem.push(row.callSuccessRatio);
        rowItem.push(row.callCntByCallee);
        rowItem.push(row.callSuccessCntByCallee);
        rowItem.push(row.callSuccessRatioByCallee);
        rowItem.push(row.scenarioStartCntByCallee);
        rowItem.push(row.scenarioEndCntByCallee);
        rowItem.push(row.scenarioEndRatioByCallee);
        rowItem.push(row.calleeCnt);

        rowDataArray.push(rowItem);
      });
      
      csvArray = csvArray.concat(aiccUtils.stringUtil.enclose2DArrayInDoubleQuotes(rowDataArray));

      const sToday = utils.now("YYYYMMDDHHmmss");
      const sCsvName = `AICC_SCHEDULE_STATISTICS_${sToday}.csv`;

      this.outCallSchedulesAsk.scheduleIdList = [];
      this.outCallSchedulesAsk.scheduleStatusList = [];

      // select box 선택한 값이 있으면 Ask 데이터에 넣는다.
      if (this.selectedcampaignValue.length > 0) {
        for (let schedule of this.selectedcampaignValue) {
          this.outCallSchedulesAsk.scheduleIdList.push(schedule.value);
        }
      }
      if (this.selectedcampaignValue.length === this.campaignDropdown.length) {
        this.outCallSchedulesAsk.scheduleIdList = [];
        this.outCallSchedulesAsk.scheduleIdList.push("전체");
      }

      if (this.selectedStatus.length > 0) {
        for (let status of this.selectedStatus) {
          this.outCallSchedulesAsk.scheduleStatusList.push(status.text);
        }
      }
      if (this.selectedStatus.length === this.selectStatusOptions.length) {
        this.outCallSchedulesAsk.scheduleStatusList = [];
        this.outCallSchedulesAsk.scheduleStatusList.push("전체");
      }

      /*  console.log(this.outCallSchedulesAsk.scheduleStatusList.toString()) */

      const fileDownloadHistoryAsk = {
        pageId: this.contextPageId,
        fileName: sCsvName,
        fileDetail: ` ${this.$i18n.t("MSG_TXT_CAMPAIGN_PERIOD")} : ${
          this.rangeDate[0]
        } ~ ${this.rangeDate[1]} & ${this.$i18n.t(
          "MSG_TXT_CAMPAIGN"
        )} : ${this.outCallSchedulesAsk.scheduleIdList.toString()} & ${this.$i18n.t(
          "MSG_TXT_STATUS"
        )} : ${this.outCallSchedulesAsk.scheduleStatusList.toString()}  `,
      };

      http
        .request(this.contextPageId, "DTS_AIZ_00001", {
          data: fileDownloadHistoryAsk,
        })
        .then((res) => {
          var blob, csvUrl, a;
          //console.log(csvArray);
          const BOM = "\uFEFF";
          var csvString = BOM + csvArray.map((r) => r.join(",")).join("\r\n");
          blob = new Blob([csvString], { type: "text/csv;charset=utf8" });
          csvUrl = URL.createObjectURL(blob);
          a = document.createElement("a");
          a.setAttribute("style", "display:none");
          a.setAttribute("href", csvUrl);
          a.setAttribute("download", sCsvName);
          document.body.appendChild(a);
          a.click();
          a.remove();
        })
        .catch((error) => {
          /* console.log(error); */
          utils.aiccMessageBox(
            "알림",
            "잠시 후 다시 시도해주세요.",
            "확인",
            null
          );
        });
    },

    showScheduleDetail(scheduleInfo, e) {
      this.pageInitialData.tabIdx = 2;
      this.pageInitialData.scheduleId = scheduleInfo.scheduleId;
      this.pageInitialData.scheduleName = scheduleInfo.scheduleName;
      this.pageInitialData.parentPageId = this.contextPageId;
      //this.tabIdx = 1;
      //this.scheduleId = scheduleInfo.scheduleId;
      this.$refs["scheduleDetailPopup"].open();
    },
    watchDate(newVal, oldVal) {
      let newsDate = newVal[0];
      let neweDate = newVal[1];
      let oldsDate = oldVal[0];
      let oldeDate = oldVal[1];

      newsDate = newsDate.replace(/-/g, "");
      neweDate = neweDate.replace(/-/g, "");
      oldsDate = oldsDate.replace(/-/g, "");
      oldeDate = oldeDate.replace(/-/g, "");

      this.sDate = newsDate;
      this.eDate = neweDate;

      if (newVal[0] !== oldVal[0] || newVal[1] !== oldVal[1]) {
        // this.checkAllSelectBox(true);
        let newValsDateObj = new Date(
          newsDate.substring(0, 4),
          newsDate.substring(4, 6) - 1,
          newsDate.substring(6, 8)
        );
        let newValeDateObj = new Date(
          neweDate.substring(0, 4),
          neweDate.substring(4, 6) - 1,
          neweDate.substring(6, 8)
        );
        let sDateObj = new Date(
          oldsDate.substring(0, 4),
          oldsDate.substring(4, 6) - 1,
          oldsDate.substring(6, 8)
        );
        let eDateObj = new Date(
          oldeDate.substring(0, 4),
          oldeDate.substring(4, 6) - 1,
          oldeDate.substring(6, 8)
        );
        let fromDateObj;
        let toDateObj;
        if (newVal[0] !== oldVal[0]) {
          fromDateObj = newValsDateObj;
        } else {
          fromDateObj = sDateObj;
        }
        if (newVal[1] !== oldVal[1]) {
          toDateObj = newValeDateObj;
        } else {
          toDateObj = eDateObj;
        }

        //console.log(fromDateObj);
        //console.log(toDateObj);

        let betweenTime_3month_check = Math.abs(
          toDateObj.getTime() - fromDateObj.getTime()
        );
        let betweenDay_3month_check = Math.floor(
          betweenTime_3month_check / (1000 * 60 * 60 * 24)
        );

        if (betweenDay_3month_check > 92) {
          utils.messageBox(
            "information",
            this.$t("MSG_TXT_SEARCH_UNTIL_3MONTH")
          );
        } else {
          this.getOutCallScheduleStatisticsList();
        }
      }
    },
  },

  datasets: [
    {
      id: "listDataset",
      type: "local",
      data: "listLocaldata",
      datafields: [
        {
          name: "schedulePeriod",
          type: "string",
          map: "schedulePeriod",
        },
        {
          name: "scheduleName",
          type: "string",
          map: "scheduleName",
        },
        {
          name: "sipNumber",
          type: "string",
          map: "sipNumber",
        },
        {
          name: "scheduleStatus",
          type: "string",
          map: "scheduleStatus",
        },
        {
          name: "calleeCnt",
          type: "string",
          map: "calleeCnt",
        },
        {
          name: "callTotalCnt",
          type: "string",
          map: "callTotalCnt",
        },
        {
          name: "callSuccessCnt",
          type: "string",
          map: "callSuccessCnt",
        },
        {
          name: "callSuccessRatio",
          type: "string",
          map: "callSuccessRatio",
        },
        {
          name: "callReserveCnt",
          type: "string",
          map: "callReserveCnt",
        },
        {
          name: "callCntByCallee",
          type: "string",
          map: "callCntByCallee",
        },
        {
          name: "callSuccessCntByCallee",
          type: "string",
          map: "callSuccessCntByCallee",
        },
        {
          name: "callSuccessRatioByCallee",
          type: "string",
          map: "callSuccessRatioByCallee",
        },
        {
          name: "scenarioStartCntByCallee",
          type: "string",
          map: "scenarioStartCntByCallee",
        },
        {
          name: "scenarioEndCntByCallee",
          type: "string",
          map: "scenarioEndCntByCallee",
        },
        {
          name: "scenarioEndRatioByCallee",
          type: "string",
          map: "scenarioEndRatioByCallee",
        },
      ],
    },
  ],
};
</script>

<style scoped>
::v-deep
  .ur-data-grid
  > .ur-data-grid__table
  > .ur-data-grid__content
  > .ur-data-grid__content__scroll-wrapper
  > .ur-data-grid__content__scorll-holder
  > .ur-data-grid__content__row {
  cursor: pointer;
}
::v-deep
  .ur-data-grid
  > .ur-data-grid__table
  > .ur-data-grid__content.ur-data-grid__content--infinity
  > .ur-data-grid__pseudo-scroll--wrapper
  > .ur-data-grid__pseudo-scroll.ur-data-grid__pseudo-scroll--vertical
  > .ur-data-grid__pseudo-scroll__track
  > .ur-data-grid__pseudo-scroll__thumb {
  height: 100px;
}

::v-deep
  .ur-date-picker.ur-date-picker-range.ur-input.ur-date-picker--medium
  > .ur-date-picker-wrapper
  > .ur-text-field.ur-input.ur-date-picker__text-field.ur-text-field--medium.ur-text-field--border {
  width: 138px;
}
::v-deep
  .ur-date-picker.ur-date-picker-range.ur-input.ur-date-picker--medium
  > .ur-date-picker-wrapper
  > .wave.ur-icon-wrapper {
  width: 24px;
}
</style>